Vue.component('ack-pac-dent', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-pac-dent',
	mixins: [languageMixins],
	created() {
		this.selectInitialProduct();
	},
	mounted() {
		appLog.log('ack-pac-dent mounted');
		//this.setPageIsLoading(false)
	},
	props: {
		productLocalJsonUrl: {
			type: String,
			required: false,
		},
		initialProductId: {
			type: [String, Number],
			required: false,
			default: null,
		},
	},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('localization', ['countryCode', 'userLanguage']),
		...Vuex.mapGetters('resins', ['selectedPacDentShopifyProduct']),
		...Vuex.mapState('resins', ['selectedPacDentProductId']),
		/*
      lastArticles(){
        let arr = []
        for (let index = 0; index < 3; index++) {
          const element = this.articlesArray[index];
          arr.push(element)
        }
        return arr
      },
      */
		isMobile() {
			return this.$parent.isMobile;
		},
		storeAvailable() {
			let avl = true;
			if (
				this.countryCode.toUpperCase() == 'US' ||
				this.countryCode.toUpperCase() == 'CA' ||
				this.countryCode.toUpperCase() == 'TW'
			) {
				avl = false;
			}
			return avl;
		},
		isBioArchPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7419338063975';
		},
		isTryInPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7346083889255';
		},
		isTruModelPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7419335999591';
		},
		isSurgicalGuide2Page() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499845599335';
		},
		isOrthoIBTPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499855003751';
		},
		isCastablePage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499855855719';
		},
		isBiteTrayPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499848220775';
		},
		isAdhesiveKitPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '6908636790887';
		},
		isResinCleanerPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7412868808807';
		},
		isEnVisionPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7345446813799';
		},
		isTitanPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '6908629811303';
		},
		isSculpturePage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '6908625911911';
		},
		isDentureBasePage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '6908632727655';
		},
		isFlexiSplintPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499835900007';
		},
		isSplint2Page() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7499834064999';
		},
		isN2FreeGlazePage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7211636359271';
		},
		isNaturalizingKit2Page() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7211598381159';
		},
		isLutingCementPage() {
			return String(this.selectedPacDentProductId || this.initialProductId) === '7346161123431';
		},
		hideSharedComparisonSections() {
			return (
				this.isBioArchPage ||
				this.isTryInPage ||
				this.isTruModelPage ||
				this.isSurgicalGuide2Page ||
				this.isOrthoIBTPage ||
				this.isCastablePage ||
				this.isBiteTrayPage ||
				this.isAdhesiveKitPage
			);
		},
		purchaseControlMode() {
			return this.isTryInPage ||
				this.isFlexiSplintPage ||
				this.isSplint2Page ||
				this.isN2FreeGlazePage ||
				this.isNaturalizingKit2Page ||
				this.isLutingCementPage ||
				this.isResinCleanerPage
				? 'button'
				: 'variant';
		},
		materialComparisonSectionData() {
			if (this.isN2FreeGlazePage) {
				return this.pacDentInfo.material_comparison_section_n2_free_glaze;
			}

			if (this.isDentureBasePage) {
				return this.pacDentInfo.material_comparison_section_denture;
			}

			if (this.isSculpturePage) {
				return this.pacDentInfo.material_comparison_section_sculpture;
			}

			if (this.isTitanPage) {
				return this.pacDentInfo.material_comparison_section_titan;
			}

			return this.isEnVisionPage
				? this.pacDentInfo.material_comparison_section_envision
				: this.pacDentInfo.material_comparison_section;
		},
		comparisonCardsSectionData() {
			if (this.isSculpturePage) {
				return this.pacDentInfo.comparison_cards_section_sculpture;
			}

			if (this.isTitanPage) {
				return this.pacDentInfo.comparison_cards_section_titan;
			}

			return this.isEnVisionPage
				? this.pacDentInfo.comparison_cards_section_envision
				: this.pacDentInfo.comparison_cards_section;
		},
		workflowCardsSectionData() {
			if (this.isLutingCementPage) {
				return this.pacDentInfo.workflow_cards_section_luting_cement;
			}

			if (this.isResinCleanerPage) {
				return this.pacDentInfo.workflow_cards_section_resin_cleaner;
			}

			if (this.isNaturalizingKit2Page) {
				return this.pacDentInfo.workflow_cards_section_naturalizing_kit_2;
			}

			if (this.isN2FreeGlazePage) {
				return this.pacDentInfo.workflow_cards_section_n2_free_glaze;
			}

			if (this.isSplint2Page) {
				return this.pacDentInfo.workflow_cards_section_splint_2;
			}

			if (this.isFlexiSplintPage) {
				return this.pacDentInfo.workflow_cards_section_flexisplint;
			}

			if (this.isDentureBasePage) {
				return this.pacDentInfo.workflow_cards_section_denture;
			}

			if (this.isSculpturePage) {
				return this.pacDentInfo.workflow_cards_section_sculpture;
			}

			if (this.isTitanPage) {
				return this.pacDentInfo.workflow_cards_section_titan;
			}

			return this.isEnVisionPage
				? this.pacDentInfo.workflow_cards_section_envision
				: this.pacDentInfo.workflow_cards_section;
		},
	},
	data() {
		return {
			pageId: 'pac-dent-page',
			selectedCard: null,
			activeItem: null,
			default_3dps_bundle: 'shop-3dps-6',
			pacDentInfo: {
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'resins.main_title',
					subtitle: 'resins.main_subtitle',
					title_img: window.ackShopifyFileUrl('Logo_Resize-08.png'),
					description: 'resins.main_description',
					image_desktop: window.ackShopifyFileUrl(
						'PacDent_Page_Top_banner_8e02cd42-3cbe-4366-9150-3da5f0811d45.jpg',
					),
					image_mobile: null,
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				feature_section: {
					description: null,
					default_img: window.ackShopifyFileUrl('ALPHA_AI_V4_Orient_Stack___Nest.gif'),
					feature_items: [
						{
							title: 'resins.feature_section.feature_items.item_one.title',
							description: 'resins.feature_section.feature_items.item_one.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_Scanning.jpg'),
							open: true,
						},
						{
							title: 'resins.feature_section.feature_items.item_two.title',
							description: 'resins.feature_section.feature_items.item_two.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_1_CAM.jpg'),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_three.title',
							description: 'resins.feature_section.feature_items.item_three.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_2_3D_Printing.jpg'),

							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_four.title',
							description: 'resins.feature_section.feature_items.item_four.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_Cleaning_Process.jpg'),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_five.title',
							description: 'resins.feature_section.feature_items.item_five.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_5_UV_Curing.jpg'),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_six.title',
							description: 'resins.feature_section.feature_items.item_six.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_4_Characterization.jpg'),
							open: false,
						},
						{
							title: 'resins.feature_section.feature_items.item_seven.title',
							description: 'resins.feature_section.feature_items.item_seven.description',
							link: null,
							image: window.ackShopifyFileUrl('PacDent_Page_Workflow_6_Seating.jpg'),
							open: false,
						},
					],
				},
				media_grid_section: {
					title: 'resins.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title: 'resins.media_grid_section.media_grid_collection.main_item.title',
							description: 'resins.media_grid_section.media_grid_collection.main_item.description',
							img: window.ackShopifyFileUrl('PacDent_Page_Successful_Cases_Nelson_Rego.jpg'),
						},
						secondary_item: {
							title: 'resins.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'resins.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: window.ackShopifyFileUrl('PacDent_Page_Successful_Cases_Gupta.jpg'),
						},
						tertiary_item_one: {
							title: 'resins.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'resins.media_grid_section.media_grid_collection.secondary_item.description',
							img: window.ackShopifyFileUrl('PacDent_Page_Successful_Cases_Jose_Antonio.jpg'),
						},
						tertiary_item_two: {
							title: 'resins.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'resins.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: window.ackShopifyFileUrl('PacDent_Page_Successful_Cases_Eugene.jpg'),
						},
					},
				},
				video_section: {
					title: 'resins.video_section.title',
					subtitle: null,
					description: 'resins.video_section.description',
					video: window.ackShopifyFileUrl('ALPHA-AI_V4_Variable_Layer_Thickness.gif'),
				},
				product_menu_section: {
					//Rodin Resins Line
					resins: {
						title: 'Rodin Resins Line',
						menu_items: [
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_TruModel.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_RapidCeram.png'),
								id: 'truModel',
								productId: '7419335999591',
								link: '#truModel',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_RapidCeram.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_RapidCeram.png'),
								id: 'rapidCeram',
								productId: '7345430462567',
								link: '#rapidCeram',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_EnVision.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_EnVision.png'),
								id: 'enVision',
								productId: '7345446813799',
								link: '#enVision',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Sculpture_2.0.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Sculpture_2.0.png'),
								id: 'sculpture_2',
								productId: '6908625911911',
								link: '#sculpture_2',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Titan.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Titan.png'),
								id: 'titan',
								productId: '6908629811303',
								link: '#titan',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Denture_Base_2.0.png'),
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Base_2.0.png?v=1782094153',
								id: 'denture_2',
								productId: '6908632727655',
								link: '#denture_2',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_BioArch_RPD.png'),
								imageLogo: '',
								id: 'bioArchRPD',
								productId: '7419338063975',
								link: '#bioArchRPD',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Try-In.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Try-In.png'),
								id: 'tryIn',
								productId: '7346083889255',
								link: '#tryIn',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Splint_2.0.png'),
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint_2.0_Rigid.png?v=1782096446',
								id: 'splint_2',
								productId: '7499834064999',
								link: '#splint_2',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Flexisplint.png'),
								imageLogo:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint.png?v=1782096226',
								id: 'flexisplint',
								productId: '7499835900007',
								link: '#flexisplint',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Surgical_Guide_2.0.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Surgical_Guide_2.0.png'),
								id: 'surgicalGuide_2',
								productId: '7499845599335',
								link: '#surgicalGuide_2',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Ortho-IBT.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Ortho_IBT.png'),
								id: 'orthoIBT',
								productId: '7499855003751',
								link: '#orthoIBT',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Bite_Tray.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Bite_Tray.png'),
								id: 'biteTray',
								productId: '7499848220775',
								link: '#biteTray',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Castable.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Castable.png'),
								id: 'castable',
								productId: '7499855855719',
								link: '#castable',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Icon_Resin_Cleaner.png'),
								imageLogo: '',
								id: 'resin_cleaner',
								productId: '7412868808807',
								link: '#resin_cleaner',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_N2-Free_Glaze.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Glaze_N2-Free.png'),
								id: 'n2_free_glaze',
								productId: '7211636359271',
								link: '#n2_free_glaze',
							},

							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Palette_2.0_Kit.png'),
								imageLogo: window.ackShopifyFileUrl(
									'Rodin_Card_Palette_2.0_with_Glaze_N2-Free.png',
								),
								id: 'naturalizing_kit_2',
								productId: '7211598381159',
								link: '#naturalizing_kit_2',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Bond_Kit.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Bond_Kit.png'),
								id: 'adhesive_kit',
								productId: '6908636790887',
								link: '#adhesive_kit',
							},
							{
								imageMenu: window.ackShopifyFileUrl('PacDent_Page_Icon_Luting_Cement.png'),
								imageLogo: window.ackShopifyFileUrl('Rodin_Card_Luting_Cement.png'),
								id: 'lutingCement',
								productId: '7346161123431',
								link: '#lutingCement',
							},
						],
					},
					naturalizations: {
						title: 'Naturalizations Line',
						menu_items: [],
					},
					bondings: {
						title: 'Bonding Line',
						menu_items: [],
					},
				},
				article_section: {
					articles: [
						{
							title: 'The Future of 3D Printing in Dentistry',
							image: window.ackShopifyFileUrl('PacDent_Page_Thumbnail_Lee_Culp.jpg'),
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/Lee%20Culp%20CDT%20Article.pdf',
						},
						{
							title: 'The Benefits of 3D Printing in Dentistry',
							image: window.ackShopifyFileUrl('PacDent_Page_Thumbnail_Chonway.jpg'),
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/0723Odowling[5].pdf',
						},
						{
							title: 'The Advantages of 3D Printing in Dentistry',
							image: window.ackShopifyFileUrl('PacDent_Page_Thumbnail_O_Dowling.jpg'),
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/IDV19N7_Why_I_Invested_Pacdent_6th.pdf',
						},
					],
				},
				first_image_section: {
					title: 'resins.first_image_section.title',
					image: window.ackShopifyFileUrl(
						'PacDent_Page_Mechanical_Properties_Comparison_f06cfa47-5e5b-4dd7-92ed-6418e6464972.jpg',
					),
					notes: 'resins.first_image_section.notes',
				},
				second_image_section: {
					title: 'resins.second_image_section.title',
					image: window.ackShopifyFileUrl(
						'PacDent_Page_Vita_Shades_c966d301-9d7c-4efa-9a3e-406742d2df46.jpg',
					),
				},
				material_comparison_section: {
					title: 'Material Comparison',
					note: '*Data provided by Dr. Russel Giordano of Boston University',
					items: [
						{
							title: 'Weight % Filler Content of Printed Permanent Tooth Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Material_Comparison_1.png?v=1781661764',
							alt: 'Weight percent filler content chart',
						},
						{
							title: 'Three Point Flexural Strength of Printed Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Material_Comparison_3.png?v=1781661764',
							alt: 'Three point flexural strength chart',
						},
						{
							title: 'Biaxial Strength of Printed Permanent Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Material_Comparison_2.png?v=1781661764',
							alt: 'Biaxial strength chart',
						},
					],
				},
				material_comparison_section_titan: {
					title: 'Mechanical Properties Comparison',
					items: [
						{
							title: 'Three-Point Flexural Strength - ISO 4909',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Comparison_1.png?v=1782091184',
							alt: 'Three-point flexural strength comparison chart',
						},
						{
							title: 'Fracture Toughness - ISO 6872',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Comparison_2.png?v=1782091184',
							alt: 'Fracture toughness comparison chart',
						},
					],
				},
				material_comparison_section_sculpture: {
					title: 'Mechanical Properties Comparison',
					layout: 'sculpture-comparison',
					items: [
						{
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Comparison_1-80.png?v=1782093081',
							alt: 'Sculpture 2.0 mechanical properties comparison chart 1',
						},
						{
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Comparison_2-81.png?v=1782093081',
							alt: 'Sculpture 2.0 mechanical properties comparison chart 2',
						},
					],
				},
				material_comparison_section_denture: {
					title: 'University Data',
					layout: 'denture-university-data',
					description:
						'Denture Base 2.0 excels in flexural strength, fracture toughness, and work of fracture&mdash;delivering a stronger, more resilient denture base that resists cracks and absorbs stress for lasting comfort. Its balance of strength and durability makes it the ideal choice for producing reliable full-arch and implant-supported dentures through 3D printing.',
					note: '*Data provided by Dr. Russel Giordano of Boston University',
					items: [
						{
							title: 'Three Point Flexural Strength of Various Denture Base Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Date_1.png?v=1782094331',
							alt: 'Denture base flexural strength chart',
						},
						{
							title: 'Work of Fracture of Denture Base Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Date_2.png?v=1782094331',
							alt: 'Denture base work of fracture chart',
						},
						{
							title: 'Fracture Toughness of Denture Base Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Date_3.png?v=1782094331',
							alt: 'Denture base fracture toughness chart',
						},
					],
				},
				material_comparison_section_envision: {
					title: 'Material Comparison',
					layout: 'envision-highlight',
					topLeft: {
						title: 'Ultra-Thin Precision, Unmatched Strength',
						description:
							'<strong>EnVision</strong> delivers reliable structural integrity at just 0.2 mm thickness &mdash; far thinner than traditional ceramic hybrids or posterior-grade printable resins. This ultra-thin capability makes it ideal for:',
						points: [
							'<strong>Feather-edge margins</strong> in no-prep veneer cases',
							'<strong>Esthetic mockups and try-ins</strong> where minimal thickness improves fit and comfort',
							'<strong>High-definition layering</strong> for detailed anterior esthetics',
						],
						note: 'By comparison, <strong>OnX Tough 2</strong> showed instability below 0.3 mm, increasing the risk of edge fractures and post-processing detachment.',
					},
					topRight: {
						image:
							'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Chart.png?v=1781762438',
						alt: 'EnVision material comparison chart',
					},
					items: [
						{
							title: 'EnVision',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Envision_1.png?v=1781762449',
							alt: 'EnVision ultra-thin veneer samples',
						},
						{
							title: 'Other Resin Materials',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Envision_2.png?v=1781762449',
							alt: 'Other resin material samples',
						},
					],
				},
				material_comparison_section_n2_free_glaze: {
					title: 'University Data',
					layout: 'n2-free-glaze-data',
					topLeft: {
						title: 'University Data',
						description:
							'Independent third-party testing shows that when applied after printing and before final curing, Glaze N2-Free achieves a high gloss finish of 78 units with minimal polishing required. Wear simulation demonstrates durability up to 350,000 cycles&mdash;equivalent to about 2.5 years of clinical use&mdash;ensuring a strong, esthetic finish without the need for specialized curing equipment.',
					},
					topRight: {
						note: '*Data provided by Dr. Russell Giordano of Boston University',
						items: [
							{
								title: 'Simulated Clinical Longevity<br>(350,000 cycles + approx. 2.5 Years)',
								image:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Chart_1.png?v=1782099440',
								alt: 'N2-Free Glaze simulated clinical longevity chart',
							},
							{
								title: 'Gloss before Aging',
								image:
									'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Chart_2.png?v=1782099441',
								alt: 'N2-Free Glaze gloss before aging chart',
							},
						],
					},
				},
				comparison_cards_section: {
					title: 'Comparison',
					items: [
						{
							title: 'RapidCeram',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_1.png?v=1781662421',
							alt: 'RapidCeram product',
							isHighlighted: true,
							points: [
								'Recommended for Same-Day Restorations',
								'Prints up to 2x faster than traditional ceramic-filled resins',
								'Designed for same-day crowns, denture tooth arches, and bridges',
								'Over 51% ceramic filler for strength and esthetic performance',
								'Available in 600 g bottle',
								'4 Shades (A1, A2, B1, OM3)',
							],
						},
						{
							title: 'Sculpture 2.0',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_2.png?v=1781662422',
							alt: 'Sculpture 2.0 product',
							points: [
								'Recommended for Permanent Crowns',
								'Offers Best-in Class Strength and Wear Resistance',
								'Designed for Long-Term Temporary and permanent fixed restorations',
								'Over 60% ceramic filler: Zirconia-Infused',
								'Available in 1.2 kg, 600 g and 300 g Bottle',
								'18 Shades (Full Vita Classic Shade Range)',
							],
						},
						{
							title: 'Titan',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_3.png?v=1781662422',
							alt: 'Titan product',
							points: [
								'Recommended for Full Arch Restorations',
								'Provides high impact resistance for demanding full-arch cases',
								'Designed for All-on-X, full arch prosthetics, and denture tooth setups',
								'Over 51% ceramic filler for enhanced strength and rigidity',
								'Available in 1.2 kg, 600 g, and 300 g bottle sizes',
								'7 Shades (A1, A2, A3, C2, OM1, OM3)',
							],
						},
						{
							title: 'EnVision',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_4.png?v=1781662421',
							alt: 'EnVision product',
							points: [
								'Recommended for Printed Veneers',
								'Enables ultra-thin printing with reliable 0.2 mm minimum thickness',
								'Designed for no-prep and minimal-prep veneer workflows',
								'Over 51% ceramic filler for esthetic translucency and durability',
								'Available in 600 g bottle',
								'4 Shades (OM1, OM3, A, B1)',
							],
						},
					],
				},
				comparison_cards_section_titan: {
					title: 'Comparison',
					items: [
						{
							title: 'Titan',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_3.png?v=1781662422',
							alt: 'Titan product',
							isHighlighted: true,
							points: [
								'Recommended for Full Arch Restorations',
								'Provides high impact resistance for demanding full-arch cases',
								'Designed for All-on-X, full arch prosthetics, and denture tooth setups',
								'Over 51% ceramic filler for enhanced strength and rigidity',
								'Available in 1.2 kg, 600 g, and 300 g bottle sizes',
								'7 Shades (A1, A2, A3, C2, OM1, OM3)',
							],
						},
						{
							title: 'RapidCeram',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_1.png?v=1781662421',
							alt: 'RapidCeram product',
							points: [
								'Recommended for Same-Day Restorations',
								'Prints up to 2x faster than traditional ceramic-filled resins',
								'Designed for same-day crowns, denture tooth arches, and bridges',
								'Over 51% ceramic filler for strength and esthetic performance',
								'Available in 600 g bottle',
								'4 Shades (A1, A2, B1, OM3)',
							],
						},
						{
							title: 'Sculpture 2.0',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_2.png?v=1781662422',
							alt: 'Sculpture 2.0 product',
							points: [
								'Recommended for Permanent Crowns',
								'Offers Best-in Class Strength and Wear Resistance',
								'Designed for Long-Term Temporary and permanent fixed restorations',
								'Over 60% ceramic filler: Zirconia-Infused',
								'Available in 1.2 kg, 600 g and 300 g Bottle',
								'18 Shades (Full Vita Classic Shade Range)',
							],
						},
						{
							title: 'EnVision',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_4.png?v=1781662421',
							alt: 'EnVision product',
							points: [
								'Recommended for Printed Veneers',
								'Enables ultra-thin printing with reliable 0.2 mm minimum thickness',
								'Designed for no-prep and minimal-prep veneer workflows',
								'Over 51% ceramic filler for esthetic translucency and durability',
								'Available in 600 g bottle',
								'4 Shades (OM1, OM3, A, B1)',
							],
						},
					],
				},
				comparison_cards_section_sculpture: {
					title: 'Comparison',
					items: [
						{
							title: 'Sculpture 2.0',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_2.png?v=1781662422',
							alt: 'Sculpture 2.0 product',
							isHighlighted: true,
							points: [
								'Recommended for Permanent Crowns',
								'Offers Best-in Class Strength and Wear Resistance',
								'Designed for Long-Term Temporary and permanent fixed restorations',
								'Over 60% ceramic filler: Zirconia-Infused',
								'Available in 1.2 kg, 600 g and 300 g Bottle',
								'18 Shades (Full Vita Classic Shade Range)',
							],
						},
						{
							title: 'RapidCeram',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_1.png?v=1781662421',
							alt: 'RapidCeram product',
							points: [
								'Recommended for Same-Day Restorations',
								'Prints up to 2x faster than traditional ceramic-filled resins',
								'Designed for same-day crowns, denture tooth arches, and bridges',
								'Over 51% ceramic filler for strength and esthetic performance',
								'Available in 600 g bottle',
								'4 Shades (A1, A2, B1, OM3)',
							],
						},
						{
							title: 'Titan',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_3.png?v=1781662422',
							alt: 'Titan product',
							points: [
								'Recommended for Full Arch Restorations',
								'Provides high impact resistance for demanding full-arch cases',
								'Designed for All-on-X, full arch prosthetics, and denture tooth setups',
								'Over 51% ceramic filler for enhanced strength and rigidity',
								'Available in 1.2 kg, 600 g, and 300 g bottle sizes',
								'7 Shades (A1, A2, A3, C2, OM1, OM3)',
							],
						},
						{
							title: 'EnVision',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_4.png?v=1781662421',
							alt: 'EnVision product',
							points: [
								'Recommended for Printed Veneers',
								'Enables ultra-thin printing with reliable 0.2 mm minimum thickness',
								'Designed for no-prep and minimal-prep veneer workflows',
								'Over 51% ceramic filler for esthetic translucency and durability',
								'Available in 600 g bottle',
								'4 Shades (OM1, OM3, A, B1)',
							],
						},
					],
				},
				comparison_cards_section_envision: {
					title: 'Comparison',
					items: [
						{
							title: 'EnVision',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_4.png?v=1781662421',
							alt: 'EnVision product',
							isHighlighted: true,
							points: [
								'Recommended for Printed Veneers',
								'Enables ultra-thin printing with reliable 0.2 mm minimum thickness',
								'Designed for no-prep and minimal-prep veneer workflows',
								'Over 51% ceramic filler for esthetic translucency and durability',
								'Available in 600 g bottle',
								'4 Shades (OM1, OM3, A, B1)',
							],
						},
						{
							title: 'Sculpture 2.0',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_2.png?v=1781662422',
							alt: 'Sculpture 2.0 product',
							points: [
								'Recommended for Permanent Crowns',
								'Offers Best-in Class Strength and Wear Resistance',
								'Designed for Long-Term Temporary and permanent fixed restorations',
								'Over 60% ceramic filler: Zirconia-infused',
								'Available in 1.2 kg, 600 g and 300 g Bottle',
								'18 Shades (Full Vita Classic Shade Range)',
							],
						},
						{
							title: 'Titan',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_3.png?v=1781662422',
							alt: 'Titan product',
							points: [
								'Recommended for Full Arch Restorations',
								'Provides high impact resistance for demanding full-arch cases',
								'Designed for All-on-X, full arch prosthetics, and denture tooth setups',
								'Over 51% ceramic filler for enhanced strength and rigidity',
								'Available in 1.2 kg, 600 g, and 300 g bottle sizes',
								'7 Shades (A1, A2, A3, C2, OM1, OM3)',
							],
						},
						{
							title: 'RapidCeram',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_-_Comparison_1.png?v=1781662421',
							alt: 'RapidCeram product',
							points: [
								'Recommended for Same-Day Restorations',
								'Prints up to 2x faster than traditional ceramic-filled resins',
								'Designed for same-day crowns, denture tooth arches, and bridges',
								'Over 51% ceramic filler for strength and esthetic performance',
								'Available in 600 g bottle',
								'4 Shades (A1, A2, B1, OM3)',
							],
						},
					],
				},
				workflow_cards_section: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Prep Tooth for Temporary Crown',
							description: 'Prep tooth to ensure proper fit and retention for the temporary crown.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_1.png?v=1781663790',
						},
						{
							title: 'Scan Prep with Intraoral Scanner',
							description:
								'Capture a digital impression of the prepared tooth using an intraoral scanner for accurate design.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_2.png?v=1781663791',
						},
						{
							title: 'Design, Nest & Print Crown',
							description:
								'Design a 3D model of the crown using CAD software, nest it for printing, and fabricate it using a resin printer.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_3.png?v=1781663791',
						},
						{
							title: 'Remove Excess Resin',
							description:
								'Gently remove excess resin with a brush soaked in <a href="/products/resin-cleaner" style="text-decoration: underline;">Rodin Universal Resin Cleaner</a>.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_4.png?v=1781663790',
						},
						{
							title: 'Trim Print Supports',
							description:
								'Carefully trim nesting supports and Adjust crown with a low speed handpiece to avoid microfractures, make adjustments to contacts and occlusal areas for a precise fit.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_5.png?v=1781663790',
						},
						{
							title: 'Test Seat, Stain & Glaze',
							description:
								'Gently trial seat the crown, adjust if necessary; stain & glaze intraorally or extraorally using Palette 2.0 Stain & Glaze N2-Free.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_6.png?v=1781663790',
						},
						{
							title: 'Post-Cure Crown in Curing Unit',
							description:
								'Cure the printed crown in a post-curing unit to enhance strength and biocompatibility.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_7.png?v=1781663790',
						},
						{
							title: 'Load Temporary Cement',
							description:
								'Apply a thin layer of temporary cement (such as PacTemp NE) inside the crown.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_8.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_RapidCeram_Workflow_8.png?v=1781663790',
						},
					],
				},
				workflow_cards_section_titan: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Prep and Scan',
							description:
								'A full oral evaluation is completed using digital impressions, intraoral scans, and CBCT imaging to assess jawbone structure, bone density, and ideal implant sites. Guided surgery software then virtually plans implant placement with optimal angulation and stability to ensure strong support for the full-arch prosthesis.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_1.png?v=1782092384',
						},
						{
							title: 'Design',
							description:
								'In the design software of your choice, integrate all the required inputs to generate the All-on-X design. Be sure to adjust the tooth anatomy, contacts, and occlusion for optimal fit and function.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_2.png?v=1782092384',
						},
						{
							title: 'Print Guides & Implants',
							description:
								'If needed, surgical guides are printed with <a href="/products/rodin-surgical-guide-2-1" style="text-decoration: underline;">Rodin Surgical Guide 2.0</a> to provide a precise, secure template that follows the pre-planned implant positions, angles, and depths for maximum accuracy and minimally invasive placement. After finalizing the All-on-X design, the model is nested in the printer software, sent to the 3D printer, and printed using Titan resin.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_3.png?v=1782092384',
						},
						{
							title: 'Wash and Clean',
							description:
								'After the print is complete, remove restoration from build plate. Remove supports from the restoration and follow manufacturer instructions for use for wash and post-processing procedures.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_4.png?v=1782092384',
						},
						{
							title: 'Adjustments',
							description:
								'Before final curing, adjust contacts, contours, and occlusion, then apply Rodin Palette and Glaze N2-Free in the uncured state for optimal chemical bonding and post-cure as recommended. Attach the housings, place composite in the caps, seat the prosthesis, confirm adaptation, and make any final adjustments for comfort and function.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_5.png?v=1782092384',
						},
						{
							title: 'Stain, Glaze and Cure',
							description:
								'Complete all polishing, characterization, and finishing to achieve a natural look and verify the prosthesis meets standards for comfort, retention, and aesthetics. Cement the implant housings before final post-curing for durability, and a <a href="/products/trumodel" style="text-decoration: underline;">Rodin TruModel</a> study cast study cast as needed to confirm dimensional fit.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_6.png?v=1782092384',
						},
						{
							title: 'Final Polish & Delivery',
							description:
								'Secure the prosthetic arch onto the implants using the selected attachment system. Provide the patient with hygiene and maintenance instructions to ensure they understand proper care and long-term stability of their new fixed full-arch restoration.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Titan_Workflow_7.png?v=1782092384',
						},
					],
				},
				workflow_cards_section_denture: {
					title: 'Recommended Finishing Workflow',
					layout: 'four-columns',
					items: [
						{
							title: '1st Coat of Glaze',
							description:
								'Apply Glaze N2-Free into denture base sockets before seating teeth, push down and allow excess to pool out.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Workflow_1.png?v=1782095062',
						},
						{
							title: 'Stain Using Palette',
							description:
								'Use Rodin Palette 2.0 with Pac-Dent micro-applicators to apply palette in layers, tack-cure each and blend with Glaze N2-Free for richer color.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Workflow_2.png?v=1782095061',
						},
						{
							title: '2nd Coat of Glaze',
							description:
								'Use the excess Glaze N2-Free to apply a final coat to create a durable stain and wear resistant finish for additional protection and esthetics.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Workflow_3.png?v=1782095061',
						},
						{
							title: 'Final Cure',
							description:
								'The final post-curing process is vital as it fuses all layers of a 3D-printed restorations into a monolithic printed denture.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Denture_Workflow_4.png?v=1782095061',
						},
					],
				},
				workflow_cards_section_flexisplint: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Evaluation & Intraoral Scan',
							description:
								'Confirm the patient is a suitable candidate for a splint and capture accurate intraoral scans of their dentition and occlusion to create an accurate 3D model for appliance design.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_1.png?v=1782096196',
						},
						{
							title: 'Design',
							description:
								"Import the scan into CAD software to design a digital appliance that's tailored to the patient's specific indication, customized for their bite and anatomical features.",
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_2.png?v=1782096196',
						},
						{
							title: 'Printing & Post-Processing',
							description:
								'After 3D printing the splint using a validated printer, remove it from the build platform and perform an initial alcohol rinse (IPA or ethanol) to remove excess resin.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_3.png?v=1782096196',
						},
						{
							title: 'Trimming & Finishing',
							description:
								'Use lab acrylic and carbide burs to refine the margins, adjust occlusion if necessary, and smooth the edges for enhanced patient comfort.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_4.png?v=1782096196',
						},
						{
							title: 'Coat',
							description:
								'After polishing, brush on a thin layer of the same resin used to print, before performing a full post-cure cycle.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_5.png?v=1782096196',
						},
						{
							title: 'Post Cure',
							description:
								'Place the appliance in a validated post-curing unit to achieve full polymerization of both the appliance and glaze, ensuring optimal mechanical properties and long-term durability.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_6.png?v=1782096196',
						},
						{
							title: 'Final Polishing',
							description:
								'Perform a final high-shine polish using a polishing wheel and paste, then deliver the splint to the patient, ensuring a proper fit, occlusal balance, and patient comfort.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Flexisplint__Workflow_7.png?v=1782096196',
						},
					],
				},
				workflow_cards_section_splint_2: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Evaluation & Intraoral Scan',
							description:
								'Confirm the patient is a suitable candidate for a splint and capture accurate intraoral scans of their dentition and occlusion to create an accurate 3D model for appliance design.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_1.png?v=1782097016',
						},
						{
							title: 'Design',
							description:
								"Import the scan into CAD software to design a digital appliance that's tailored to the patient's specific indication, customized for their bite and anatomical features.",
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_2.png?v=1782097016',
						},
						{
							title: 'Printing & Post-Processing',
							description:
								'After 3D printing the splint using a validated printer, remove it from the build platform and perform an initial alcohol rinse (IPA or ethanol) to remove excess resin.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_3.png?v=1782097016',
						},
						{
							title: 'Trimming & Finishing',
							description:
								'Use lab acrylic and carbide burs to refine the margins, adjust occlusion if necessary, and smooth the edges for enhanced patient comfort.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_4.png?v=1782097017',
						},
						{
							title: 'Coat',
							description:
								'After polishing, brush on a thin layer of the same resin used to print, before performing a full post-cure cycle.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_5.png?v=1782097016',
						},
						{
							title: 'Post Cure',
							description:
								'Place the appliance in a validated post-curing unit to achieve full polymerization of both the appliance and glaze, ensuring optimal mechanical properties and long-term durability.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_6.png?v=1782097016',
						},
						{
							title: 'Final Polishing',
							description:
								'Perform a final high-shine polish using a polishing wheel and paste, then deliver the splint to the patient, ensuring a proper fit, occlusal balance, and patient comfort.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Splint__Workflow_7.png?v=1782097017',
						},
					],
				},
				workflow_cards_section_naturalizing_kit_2: {
					title: 'Recommended Workflow',
					layout: 'four-columns',
					items: [
						{
							title: '1st Coat of Glaze',
							description:
								'Apply a light, even coat of glaze to establish a smooth base layer before adding stain.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Palette_Workflow_1.png?v=1782108019',
						},
						{
							title: 'Stain Using Palette',
							description:
								'Use Rodin Palette to apply characterization shades and refine the esthetic value and chroma.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Palette_Workflow_2.png?v=1782108019',
						},
						{
							title: '2nd Coat of Glaze',
							description:
								'Apply a second coat of glaze to seal the surface and create a durable, high-gloss finish.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Palette_Workflow_3.png?v=1782108019',
						},
						{
							title: 'Final Cure',
							description:
								'Perform the final cure to complete polymerization and lock in the finished esthetics.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Palette_Workflow_4.png?v=1782108019',
						},
					],
				},
				workflow_cards_section_luting_cement: {
					title: 'Recommended Workflow',
					layout: 'three-columns',
					items: [
						{
							title: 'Try-In',
							description:
								'First place the restoration on the preparation to verify fit, contact, and esthetics. Use Try-In to simulate the final cement shade.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_1.png?v=1782109073',
						},
						{
							title: 'Etch & Bond',
							description:
								'Remove any provisional restoration and thoroughly clean the tooth using oil-free pumice paste. Etch tooth surface, rinse, and gently dry. Apply Rodin Bond, thin dry and light cure.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_2.png?v=1782109073',
						},
						{
							title: 'Automix Setup',
							description:
								'Remove the sealing cap and any old mixing tip from the syringe. Attach a new mixing tip, dispense and discard a small amount to ensure proper mix and eliminate residual material.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_3.png?v=1782109073',
						},
						{
							title: 'Cement Loading',
							description:
								'Dispense cement directly into the restoration, ensuring the tip stays immersed to avoid air bubbles.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_4.png?v=1782109073',
						},
						{
							title: 'Seating the Restoration',
							description: 'Seat the restoration using firm finger pressure to ensure proper fit.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_5.png?v=1782109073',
						},
						{
							title: 'Excess Cement Removal',
							description:
								'Optionally tack-cure to semi-set, facilitating excess removal, or allow to self-cure before flash removal.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_6.png?v=1782109073',
						},
						{
							title: 'Final Set & Delivery',
							description:
								'Allow final set for approximately 5 minutes after placement. Finish, check occlusion, and make any adjustments as needed.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Luting_Cement_Workflow_7.png?v=1782109073',
						},
					],
				},
				workflow_cards_section_resin_cleaner: {
					title: 'Recommended Workflow',
					layout: 'three-columns',
					items: [
						{
							title: 'Remove Excess Resin',
							description:
								'Blow off any residual resin from the printed object using compressed air.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_1.jpg?v=1782108512',
						},
						{
							title: 'Pre-wash',
							description:
								'Place the object in a turbulent wash bath or ultrasonic bath filled with Universal Resin Cleaner.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_2.jpg?v=1782108512',
						},
						{
							title: 'Secondary Cleaning',
							description:
								'Use a clean brush dipped in fresh Universal Resin Cleaner and scrub the entire surface, then rinse thoroughly with clean water.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_3.jpg?v=1782108512',
						},
						{
							title: 'Dry',
							description:
								'Blow the object dry with compressed air to remove any remaining wash solution or water.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_4.jpg?v=1782108512',
						},
						{
							title: 'Inspect',
							description:
								'Blow the object dry again with compressed air to confirm no wash solution or water remains before curing.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_5.jpg?v=1782108512',
						},
						{
							title: 'Cure',
							description:
								'Once the surface is completely clean and free of sheen, proceed with the curing process.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Resin_Cleaner_Workflow_6.jpg?v=1782108512',
						},
					],
				},
				workflow_cards_section_n2_free_glaze: {
					title: 'Recommended Workflow',
					layout: 'four-columns',
					items: [
						{
							title: '1st Coat of Glaze',
							description:
								'Apply Glaze N2-Free into denture base sockets before seating teeth, push down and allow excess to pool out.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Workflow_1.png?v=1782099442',
						},
						{
							title: 'Stain Using Palette',
							description:
								'Use Rodin Palette 2.0 with Pac-Dent micro-applicators to apply palette in layers, tack-cure each and blend with Glaze N2-Free for richer color.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Workflow_2.png?v=1782099442',
						},
						{
							title: '2nd Coat of Glaze',
							description:
								'Use the excess Glaze N2-Free to apply a final coat to create a durable stain and wear resistant finish for additional protection and esthetics.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Workflow_3.png?v=1782099442',
						},
						{
							title: 'Final Cure',
							description:
								'The final post-curing process is vital as it fuses all layers of a 3D-printed restorations into a monolithic printed denture.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_N2-Free_Glaze_Workflow_4.png?v=1782099442',
						},
					],
				},
				workflow_cards_section_sculpture: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Prep and Scan',
							description:
								'A full oral evaluation is completed using digital impressions, intraoral scans, and CBCT imaging to assess jawbone structure, bone density, and ideal implant sites. Guided surgery software then virtually plans implant placement with optimal angulation and stability to ensure strong support for the full-arch prosthesis.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_1.png?v=1782093298',
						},
						{
							title: 'Design',
							description:
								'Using the design software of your choice, input recommended design considerations to generate the ideal crown design. Make necessary adjustments to tooth anatomy, contacts, and occlusion for optimal marginal fit and function.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_2.png?v=1782093299',
						},
						{
							title: 'Print',
							description:
								'Once you have completed the crown design, nest the restoration using the associated printer software, following recommended guidelines for optimal orientation and support structures for printing accuracy and efficiency. Once complete, export the print job file to the 3D printer. Next, fill the resin vat with <a href="/products/rodin-sculpture-2-0" style="text-decoration: underline;">Sculpture 2.0</a> and initiate the print job.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_3.png?v=1782093298',
						},
						{
							title: 'Wash and Clean',
							description:
								'After the print is complete, remove restoration from build plate. Remove supports from the restoration and follow manufacturer instructions for use for wash and post-processing procedures.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_4.png?v=1782093298',
						},
						{
							title: 'Adjust and Cure',
							description:
								"Prior to final curing, make adjustments to contacts, contours, and occlusion as needed. For best chemical bonding, apply Rodin Palette and N2-Free Glaze in uncured state and post cure according to manufacturer's recommendations.",
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_5.png?v=1782093299',
						},
						{
							title: 'Cement Crown',
							description:
								'Seat crown and check for correct fit. Begin by removing the crown, then apply Rodin EtchPro to the prepared surface. Rinse thoroughly and follow with a dentin primer like Rodin Sensiguard. Next, apply Rodin Bond universal adhesive, paired with <a href="/products/rodin-luting-cement" style="text-decoration: underline;">Rodin Luting Cement</a> for optimal bonding results.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Sculpture_2.0_Workflow_6.png?v=1782093298',
						},
					],
				},
				workflow_cards_section_envision: {
					title: 'Recommended Workflow',
					items: [
						{
							title: 'Evaluation & Intraoral Scan',
							description:
								"Evaluate that patient is a good candidate for non-prep veneers; and perform intraoral scan to capture patient's dentition and occlusion.",
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_1.png?v=1781772227',
						},
						{
							title: 'Design',
							description:
								'Using CAD software to design veneers. Virtually assess gingival margins, incisal length, and occlusal clearance.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_2.png?v=1781772227',
						},
						{
							title: 'Nest & 3D Print',
							description:
								'Export and nest digital veneer files onto printer build plate. Load EnVision print settings into compatible 3D printer; fill EnVision Resin into printer vat and print.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_3.png?v=1781772227',
						},
						{
							title: 'Post-Processing',
							description:
								'Carefully remove uncured resin with an alcohol-soaked toothbrush, remove part from build plate with a spatula to avoid damage.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4.png?v=1781663629',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_4.png?v=1781772227',
						},
						{
							title: 'Stain & Glaze',
							description:
								'Gently trial seat veneers, adjust if necessary. Stain & glaze intraorally with Palette 2.0 Stain & N2-Free Glaze; tack-cure with handheld curing light if needed.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_5.png?v=1781772227',
						},
						{
							title: 'Post Cure',
							description:
								'Perform a final cure of the printed veneers in a post-curing unit to enhance strength and biocompatibility.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_6.png?v=1781772227',
						},
						{
							title: 'Try-In, Etch, Bond, & Cementation',
							description:
								'Using the restorative products in the EnVision Kit: Use Try-In to ensure shade and dimensions are accurate. Prepare tooth surface by applying EtchPro to bonding surface Apply a thin layer of Rodin Bond, air-dry and light-cure. Lastly, apply Veneer Cement onto intaglio surface and perform final light cure.',
							autoDescriptionHeight: true,
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7.png?v=1781663627',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_EnVision_Workflow_7.png?v=1781772227',
						},
					],
				},
				product_descriptions_section_envision: {
					title: 'Product & Descriptions',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_Envision_Product.png?v=1781764540',
					imageAlt: 'Rodin EnVision Product',
					items: [
						{
							title: 'Rodin Bond Dental Adhesive, 5 mL bottle',
							description:
								'A universal bonding agent that enhances adhesion between the etched tooth surface and the veneer cement. It ensures long-lasting retention and improved bond strength.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_1-50.png?v=1781764539',
						},
						{
							title: 'Glaze N2-Free, 5 mL bottle',
							description:
								"A temporary gel used to access and block the veneer's fit, shade, and overall esthetics before final cementation. It mimics the optical properties of the final cement without bonding the veneer permanently.",
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_2-51.png?v=1781764539',
						},
						{
							title: 'EtchPro Etching Gel, 3 g Syringe',
							description:
								'A light-cure veneer cement designed to provide a strong and esthetic bond between the veneer and the tooth structure. The clear formulation ensures optimal translucency and a seamless blend with natural enamel.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_3-52.png?v=1781764539',
						},
						{
							title: 'Veneer Cement, Clear, 3 g Syringe',
							description:
								'A universal bonding agent that enhances adhesion between the etched tooth surface and the veneer cement. It ensures long-lasting retention and improved bond strength.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_4-53.png?v=1781764539',
						},
						{
							title: 'Micro Applicator, 50 pcs',
							description:
								'Small, disposable applicators used to precisely apply the bonding agent and etching gel without waste.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_5-54.png?v=1781764539',
						},
						{
							title: '2 Hole Mixing-Wells, 50 pcs',
							description:
								'Small wells for dispensing and mixing bonding agents or cements before application, ensuring a controlled and hygienic workflow.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_6-55.png?v=1781764539',
						},
						{
							title: 'Pre-Bent Needle Tips, 25 pcs',
							description:
								'These curved dispensing tips allow for precise and controlled application of etching gel, bonding agent, and veneer cement, ensuring accuracy during placement.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_7-56.png?v=1781764539',
						},
						{
							title: 'Precision Dispenser Tips',
							description:
								'Specialized dispensing equipment for controlled and accurate application of all bonding and cementing materials in the EnVision workflow.',
							icon: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Rodin_8-57.png?v=1781764539',
						},
					],
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		...Vuex.mapActions('resins', ['menuItemClick']),
		...Vuex.mapActions('localization', ['fetchTranslations', 'fetchLocalTranslations']),

		onMainTranslationsLoaded() {},

		onResinMenuItemClick(item) {
			this.menuItemClick(item.productId);
		},
		selectInitialProduct() {
			if (!this.initialProductId) return;

			const initialItem = this.formatMenuItems(this.pacDentInfo.product_menu_section).find(
				(item) => String(item.productId) === String(this.initialProductId),
			);

			if (initialItem) {
				this.menuItemClick(initialItem);
			}
		},
		formatMenuItems(datas) {
			let result = [];
			for (const key in datas) {
				result = [...result, ...datas[key].menu_items];
			}
			return result;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
